var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 2,
    viewBox: "0 0 12 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.0918 1.95312C0.941406 1.95312 0.80013 1.91439 0.667969 1.83691C0.535807 1.75488 0.428711 1.64779 0.34668 1.51562C0.264648 1.37891 0.223633 1.23079 0.223633 1.07129C0.223633 0.911784 0.264648 0.765951 0.34668 0.633789C0.428711 0.501628 0.535807 0.39681 0.667969 0.319336C0.80013 0.237305 0.941406 0.196289 1.0918 0.196289H10.9014C11.0563 0.196289 11.1999 0.237305 11.332 0.319336C11.4642 0.39681 11.569 0.501628 11.6465 0.633789C11.7285 0.765951 11.7695 0.911784 11.7695 1.07129C11.7695 1.23079 11.7285 1.37891 11.6465 1.51562C11.569 1.64779 11.4642 1.75488 11.332 1.83691C11.1999 1.91439 11.0563 1.95312 10.9014 1.95312H1.0918Z",
    fill: "#052C42",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusIcon);
export default __webpack_public_path__ + "static/media/minusIcon.518d61dcdc07b0b888b3f36c66d14696.svg";
export { ForwardRef as ReactComponent };